/**
 * API Configuration
 * Manages proxy vs direct API access mode
 */

import { getTurnstileHeaders } from '@lib/turnstile'

export const API_CONFIG = {
  // Cloudflare Worker proxy base URL
  PROXY_BASE_URL: import.meta.env.VITE_API_PROXY_URL || 'https://rocketshipreaders-api.greg-035.workers.dev',

  // OpenAI direct API base
  OPENAI_BASE_URL: 'https://api.openai.com',

  // Endpoints
  TTS_PATH: '/v1/audio/speech',
  TRANSCRIPTION_PATH: '/v1/audio/transcriptions',
} as const

export type ApiMode = 'proxy' | 'direct'

/**
 * Get the base URL for API requests based on mode
 */
export function getApiBaseUrl(mode: ApiMode): string {
  return mode === 'proxy' ? API_CONFIG.PROXY_BASE_URL : API_CONFIG.OPENAI_BASE_URL
}

/**
 * Get headers for proxy requests (includes timestamp for validation)
 */

export async function getProxyHeaders(): Promise<Record<string, string>> {
  const headers: Record<string, string> = {
    'X-Request-Time': String(Date.now()),
  }

  Object.assign(headers, await getTurnstileHeaders())
  return headers
}
